var _rect, _g, _rect2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStoreQrV2(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 10,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9147_38331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4483 44.483H10V47.9313H13.4483V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4483 47.9313H10V51.3796H13.4483V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4483 58.2761H10V61.7244H13.4483V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4483 61.7244H10V65.1727H13.4483V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4483 72.0692H10V75.5175H13.4483V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 41.0347H13.4483V44.483H16.8966V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 44.483H13.4483V47.9313H16.8966V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 51.3796H13.4483V54.8278H16.8966V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 54.8278H13.4483V58.2761H16.8966V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 61.7244H13.4483V65.1727H16.8966V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 72.0692H13.4483V75.5175H16.8966V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 75.5175H13.4483V78.9658H16.8966V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8966 78.9658H13.4483V82.414H16.8966V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 37.5865H16.8966V41.0347H20.3448V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 41.0347H16.8966V44.483H20.3448V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 44.483H16.8966V47.9313H20.3448V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 47.9313H16.8966V51.3796H20.3448V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 54.8278H16.8966V58.2761H20.3448V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 65.1727H16.8966V68.6209H20.3448V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 68.6209H16.8966V72.0692H20.3448V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 75.5175H16.8966V78.9658H20.3448V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 78.9658H16.8966V82.414H20.3448V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 47.9313H20.3448V51.3796H23.7931V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 51.3796H20.3448V54.8278H23.7931V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 54.8278H20.3448V58.2761H23.7931V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 61.7244H20.3448V65.1727H23.7931V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 65.1727H20.3448V68.6209H23.7931V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 75.5175H20.3448V78.9658H23.7931V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 78.9658H20.3448V82.414H23.7931V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 37.5865H23.7931V41.0347H27.2414V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 41.0347H23.7931V44.483H27.2414V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 58.2761H23.7931V61.7244H27.2414V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 61.7244H23.7931V65.1727H27.2414V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 65.1727H23.7931V68.6209H27.2414V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 68.6209H23.7931V72.0692H27.2414V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 72.0692H23.7931V75.5175H27.2414V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 37.5865H27.2414V41.0347H30.6897V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 41.0347H27.2414V44.483H30.6897V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 44.483H27.2414V47.9313H30.6897V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 54.8278H27.2414V58.2761H30.6897V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 61.7244H27.2414V65.1727H30.6897V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 65.1727H27.2414V68.6209H30.6897V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 75.5175H27.2414V78.9658H30.6897V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6897 78.9658H27.2414V82.414H30.6897V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 37.5865H30.6897V41.0347H34.1379V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 44.483H30.6897V47.9313H34.1379V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 51.3796H30.6897V54.8278H34.1379V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 58.2761H30.6897V61.7244H34.1379V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 65.1727H30.6897V68.6209H34.1379V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 72.0692H30.6897V75.5175H34.1379V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 78.9658H30.6897V82.414H34.1379V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5862 41.0347H34.1379V44.483H37.5862V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5862 44.483H34.1379V47.9313H37.5862V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5862 54.8278H34.1379V58.2761H37.5862V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5862 58.2761H34.1379V61.7244H37.5862V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5862 68.6209H34.1379V72.0692H37.5862V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 13.4485H37.5862V16.8968H41.0345V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 23.7933H37.5862V27.2416H41.0345V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 30.6899H37.5862V34.1382H41.0345V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 37.5865H37.5862V41.0347H41.0345V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 41.0347H37.5862V44.483H41.0345V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 44.483H37.5862V47.9313H41.0345V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 54.8278H37.5862V58.2761H41.0345V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 68.6209H37.5862V72.0692H41.0345V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 75.5175H37.5862V78.9658H41.0345V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 78.9658H37.5862V82.414H41.0345V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 82.414H37.5862V85.8623H41.0345V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 89.3106H37.5862V92.7589H41.0345V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 92.7589H37.5862V96.2071H41.0345V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0345 99.6554H37.5862V103.104H41.0345V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 10.0002H41.0345V13.4485H44.4828V10.0002Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 13.4485H41.0345V16.8968H44.4828V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 16.8968H41.0345V20.3451H44.4828V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 20.3451H41.0345V23.7933H44.4828V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 37.5865H41.0345V41.0347H44.4828V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 44.483H41.0345V47.9313H44.4828V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 47.9313H41.0345V51.3796H44.4828V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 51.3796H41.0345V54.8278H44.4828V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 61.7244H41.0345V65.1727H44.4828V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 68.6209H41.0345V72.0692H44.4828V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 72.0692H41.0345V75.5175H44.4828V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 85.8623H41.0345V89.3106H44.4828V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 92.7589H41.0345V96.2071H44.4828V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 96.2071H41.0345V99.6554H44.4828V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 99.6554H41.0345V103.104H44.4828V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 103.104H41.0345V106.552H44.4828V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4828 106.552H41.0345V110H44.4828V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 13.4485H44.4828V16.8968H47.931V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 20.3451H44.4828V23.7933H47.931V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 27.2416H44.4828V30.6899H47.931V27.2416Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 30.6899H44.4828V34.1382H47.931V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 34.1382H44.4828V37.5865H47.931V34.1382Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 37.5865H44.4828V41.0347H47.931V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 44.483H44.4828V47.9313H47.931V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 47.9313H44.4828V51.3796H47.931V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 61.7244H44.4828V65.1727H47.931V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 65.1727H44.4828V68.6209H47.931V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 72.0692H44.4828V75.5175H47.931V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 78.9658H44.4828V82.414H47.931V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 82.414H44.4828V85.8623H47.931V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 96.2071H44.4828V99.6554H47.931V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.931 106.552H44.4828V110H47.931V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 10.0002H47.931V13.4485H51.3793V10.0002Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 13.4485H47.931V16.8968H51.3793V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 27.2416H47.931V30.6899H51.3793V27.2416Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 37.5865H47.931V41.0347H51.3793V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 41.0347H47.931V44.483H51.3793V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 47.9313H47.931V51.3796H51.3793V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 51.3796H47.931V54.8278H51.3793V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 54.8278H47.931V58.2761H51.3793V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 65.1727H47.931V68.6209H51.3793V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 68.6209H47.931V72.0692H51.3793V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 75.5175H47.931V78.9658H51.3793V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 78.9658H47.931V82.414H51.3793V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 82.414H47.931V85.8623H51.3793V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 92.7589H47.931V96.2071H51.3793V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 103.104H47.931V106.552H51.3793V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3793 106.552H47.931V110H51.3793V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 10.0002H51.3793V13.4485H54.8276V10.0002Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 13.4485H51.3793V16.8968H54.8276V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 20.3451H51.3793V23.7933H54.8276V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 27.2416H51.3793V30.6899H54.8276V27.2416Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 30.6899H51.3793V34.1382H54.8276V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 34.1382H51.3793V37.5865H54.8276V34.1382Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 44.483H51.3793V47.9313H54.8276V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 47.9313H51.3793V51.3796H54.8276V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 51.3796H51.3793V54.8278H54.8276V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 54.8278H51.3793V58.2761H54.8276V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 58.2761H51.3793V61.7244H54.8276V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 61.7244H51.3793V65.1727H54.8276V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 68.6209H51.3793V72.0692H54.8276V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 75.5175H51.3793V78.9658H54.8276V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 89.3106H51.3793V92.7589H54.8276V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 96.2071H51.3793V99.6554H54.8276V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8276 106.552H51.3793V110H54.8276V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 23.7933H54.8276V27.2416H58.2759V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 27.2416H54.8276V30.6899H58.2759V27.2416Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 37.5865H54.8276V41.0347H58.2759V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 44.483H54.8276V47.9313H58.2759V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 65.1727H54.8276V68.6209H58.2759V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 68.6209H54.8276V72.0692H58.2759V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 72.0692H54.8276V75.5175H58.2759V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 85.8623H54.8276V89.3106H58.2759V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 92.7589H54.8276V96.2071H58.2759V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 99.6554H54.8276V103.104H58.2759V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2759 106.552H54.8276V110H58.2759V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 13.4485H58.2759V16.8968H61.7241V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 16.8968H58.2759V20.3451H61.7241V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 23.7933H58.2759V27.2416H61.7241V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 30.6899H58.2759V34.1382H61.7241V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 37.5865H58.2759V41.0347H61.7241V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 44.483H58.2759V47.9313H61.7241V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 47.9313H58.2759V51.3796H61.7241V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 51.3796H58.2759V54.8278H61.7241V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 61.7244H58.2759V65.1727H61.7241V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 72.0692H58.2759V75.5175H61.7241V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 78.9658H58.2759V82.414H61.7241V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 92.7589H58.2759V96.2071H61.7241V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7241 106.552H58.2759V110H61.7241V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 13.4485H61.7241V16.8968H65.1724V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 20.3451H61.7241V23.7933H65.1724V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 23.7933H61.7241V27.2416H65.1724V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 27.2416H61.7241V30.6899H65.1724V27.2416Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 37.5865H61.7241V41.0347H65.1724V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 41.0347H61.7241V44.483H65.1724V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 44.483H61.7241V47.9313H65.1724V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 47.9313H61.7241V51.3796H65.1724V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 54.8278H61.7241V58.2761H65.1724V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 61.7244H61.7241V65.1727H65.1724V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 65.1727H61.7241V68.6209H65.1724V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 68.6209H61.7241V72.0692H65.1724V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 72.0692H61.7241V75.5175H65.1724V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 89.3106H61.7241V92.7589H65.1724V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 96.2071H61.7241V99.6554H65.1724V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1724 103.104H61.7241V106.552H65.1724V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 13.4485H65.1724V16.8968H68.6207V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 16.8968H65.1724V20.3451H68.6207V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 23.7933H65.1724V27.2416H68.6207V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 30.6899H65.1724V34.1382H68.6207V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 34.1382H65.1724V37.5865H68.6207V34.1382Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 37.5865H65.1724V41.0347H68.6207V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 44.483H65.1724V47.9313H68.6207V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 51.3796H65.1724V54.8278H68.6207V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 54.8278H65.1724V58.2761H68.6207V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 68.6209H65.1724V72.0692H68.6207V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 75.5175H65.1724V78.9658H68.6207V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6207 82.414H65.1724V85.8623H68.6207V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 10.0002H68.6207V13.4485H72.069V10.0002Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 20.3451H68.6207V23.7933H72.069V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 23.7933H68.6207V27.2416H72.069V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 27.2416H68.6207V30.6899H72.069V27.2416Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 41.0347H68.6207V44.483H72.069V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 65.1727H68.6207V68.6209H72.069V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 72.0692H68.6207V75.5175H72.069V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 85.8623H68.6207V89.3106H72.069V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 89.3106H68.6207V92.7589H72.069V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 92.7589H68.6207V96.2071H72.069V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.069 106.552H68.6207V110H72.069V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 20.3451H72.069V23.7933H75.5172V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 23.7933H72.069V27.2416H75.5172V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 30.6899H72.069V34.1382H75.5172V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 47.9313H72.069V51.3796H75.5172V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 51.3796H72.069V54.8278H75.5172V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 54.8278H72.069V58.2761H75.5172V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 58.2761H72.069V61.7244H75.5172V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 65.1727H72.069V68.6209H75.5172V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 68.6209H72.069V72.0692H75.5172V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 78.9658H72.069V82.414H75.5172V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 92.7589H72.069V96.2071H75.5172V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 99.6554H72.069V103.104H75.5172V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5172 106.552H72.069V110H75.5172V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 16.8968H75.5172V20.3451H78.9655V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 20.3451H75.5172V23.7933H78.9655V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 51.3796H75.5172V54.8278H78.9655V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 54.8278H75.5172V58.2761H78.9655V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 68.6209H75.5172V72.0692H78.9655V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 72.0692H75.5172V75.5175H78.9655V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 75.5175H75.5172V78.9658H78.9655V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 78.9658H75.5172V82.414H78.9655V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 92.7589H75.5172V96.2071H78.9655V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9655 96.2071H75.5172V99.6554H78.9655V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 10.0002H78.9655V13.4485H82.4138V10.0002Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 13.4485H78.9655V16.8968H82.4138V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 16.8968H78.9655V20.3451H82.4138V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 30.6899H78.9655V34.1382H82.4138V30.6899Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 37.5865H78.9655V41.0347H82.4138V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 41.0347H78.9655V44.483H82.4138V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 47.9313H78.9655V51.3796H82.4138V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 51.3796H78.9655V54.8278H82.4138V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 58.2761H78.9655V61.7244H82.4138V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 61.7244H78.9655V65.1727H82.4138V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 68.6209H78.9655V72.0692H82.4138V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 78.9658H78.9655V82.414H82.4138V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 82.414H78.9655V85.8623H82.4138V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 85.8623H78.9655V89.3106H82.4138V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 89.3106H78.9655V92.7589H82.4138V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 92.7589H78.9655V96.2071H82.4138V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 96.2071H78.9655V99.6554H82.4138V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 103.104H78.9655V106.552H82.4138V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4138 106.552H78.9655V110H82.4138V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 37.5865H82.4138V41.0347H85.8621V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 47.9313H82.4138V51.3796H85.8621V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 51.3796H82.4138V54.8278H85.8621V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 54.8278H82.4138V58.2761H85.8621V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 58.2761H82.4138V61.7244H85.8621V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 61.7244H82.4138V65.1727H85.8621V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 65.1727H82.4138V68.6209H85.8621V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 72.0692H82.4138V75.5175H85.8621V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 75.5175H82.4138V78.9658H85.8621V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 78.9658H82.4138V82.414H85.8621V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 92.7589H82.4138V96.2071H85.8621V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 99.6554H82.4138V103.104H85.8621V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 103.104H82.4138V106.552H85.8621V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8621 106.552H82.4138V110H85.8621V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 41.0347H85.8621V44.483H89.3103V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 54.8278H85.8621V58.2761H89.3103V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 61.7244H85.8621V65.1727H89.3103V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 68.6209H85.8621V72.0692H89.3103V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 75.5175H85.8621V78.9658H89.3103V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 78.9658H85.8621V82.414H89.3103V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 85.8623H85.8621V89.3106H89.3103V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 92.7589H85.8621V96.2071H89.3103V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3103 106.552H85.8621V110H89.3103V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 41.0347H89.3103V44.483H92.7586V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 58.2761H89.3103V61.7244H92.7586V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 68.6209H89.3103V72.0692H92.7586V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 72.0692H89.3103V75.5175H92.7586V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 75.5175H89.3103V78.9658H92.7586V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 78.9658H89.3103V82.414H92.7586V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 92.7589H89.3103V96.2071H92.7586V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 96.2071H89.3103V99.6554H92.7586V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7586 103.104H89.3103V106.552H92.7586V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 37.5865H92.7586V41.0347H96.2069V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 41.0347H92.7586V44.483H96.2069V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 51.3796H92.7586V54.8278H96.2069V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 68.6209H92.7586V72.0692H96.2069V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 75.5175H92.7586V78.9658H96.2069V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 78.9658H92.7586V82.414H96.2069V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 82.414H92.7586V85.8623H96.2069V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 85.8623H92.7586V89.3106H96.2069V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 89.3106H92.7586V92.7589H96.2069V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 92.7589H92.7586V96.2071H96.2069V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 44.483H96.2069V47.9313H99.6552V44.483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 47.9313H96.2069V51.3796H99.6552V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 51.3796H96.2069V54.8278H99.6552V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 54.8278H96.2069V58.2761H99.6552V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 58.2761H96.2069V61.7244H99.6552V58.2761Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 68.6209H96.2069V72.0692H99.6552V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 72.0692H96.2069V75.5175H99.6552V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 89.3106H96.2069V92.7589H99.6552V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 96.2071H96.2069V99.6554H99.6552V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 99.6554H96.2069V103.104H99.6552V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 103.104H96.2069V106.552H99.6552V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 41.0347H99.6552V44.483H103.103V41.0347Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 51.3796H99.6552V54.8278H103.103V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 54.8278H99.6552V58.2761H103.103V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 61.7244H99.6552V65.1727H103.103V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 65.1727H99.6552V68.6209H103.103V65.1727Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 68.6209H99.6552V72.0692H103.103V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 72.0692H99.6552V75.5175H103.103V72.0692Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 75.5175H99.6552V78.9658H103.103V75.5175Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 78.9658H99.6552V82.414H103.103V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 82.414H99.6552V85.8623H103.103V82.414Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 96.2071H99.6552V99.6554H103.103V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 99.6554H99.6552V103.104H103.103V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 103.104H99.6552V106.552H103.103V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 106.552H99.6552V110H103.103V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 37.5865H103.103V41.0347H106.552V37.5865Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 47.9313H103.103V51.3796H106.552V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 51.3796H103.103V54.8278H106.552V51.3796Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 54.8278H103.103V58.2761H106.552V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 61.7244H103.103V65.1727H106.552V61.7244Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 68.6209H103.103V72.0692H106.552V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 78.9658H103.103V82.414H106.552V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 85.8623H103.103V89.3106H106.552V85.8623Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 89.3106H103.103V92.7589H106.552V89.3106Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 96.2071H103.103V99.6554H106.552V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 103.104H103.103V106.552H106.552V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.552 106.552H103.103V110H106.552V106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 47.9313H106.552V51.3796H110V47.9313Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 54.8278H106.552V58.2761H110V54.8278Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 68.6209H106.552V72.0692H110V68.6209Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 78.9658H106.552V82.414H110V78.9658Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 92.7589H106.552V96.2071H110V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 96.2071H106.552V99.6554H110V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 103.104H106.552V106.552H110V103.104Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.0002V34.1382H34.1379V10.0002H10ZM13.4483 13.4485H30.6897V30.6899H13.4483V13.4485Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 16.8968H16.8966V20.3451H20.3448V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 20.3451H16.8966V23.7933H20.3448V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 23.7933H16.8966V27.2416H20.3448V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 16.8968H20.3448V20.3451H23.7931V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 20.3451H20.3448V23.7933H23.7931V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 23.7933H20.3448V27.2416H23.7931V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 16.8968H23.7931V20.3451H27.2414V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 20.3451H23.7931V23.7933H27.2414V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 23.7933H23.7931V27.2416H27.2414V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 10.0002H85.8621V34.1382H110V10.0002ZM106.552 13.4485V30.6899H89.3103V13.4485H106.552Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 16.8968H92.7586V20.3451H96.2069V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 20.3451H92.7586V23.7933H96.2069V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2069 23.7933H92.7586V27.2416H96.2069V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 16.8968H96.2069V20.3451H99.6552V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 20.3451H96.2069V23.7933H99.6552V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6552 23.7933H96.2069V27.2416H99.6552V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 16.8968H99.6552V20.3451H103.103V16.8968Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 20.3451H99.6552V23.7933H103.103V20.3451Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.103 23.7933H99.6552V27.2416H103.103V23.7933Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 110H34.1379V85.8623H10V110ZM13.4483 106.552V89.3106H30.6897V106.552H13.4483Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 92.7589H16.8966V96.2071H20.3448V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 96.2071H16.8966V99.6554H20.3448V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3448 99.6554H16.8966V103.104H20.3448V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 92.7589H20.3448V96.2071H23.7931V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 96.2071H20.3448V99.6554H23.7931V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7931 99.6554H20.3448V103.104H23.7931V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 92.7589H23.7931V96.2071H27.2414V92.7589Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 96.2071H23.7931V99.6554H27.2414V96.2071Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2414 99.6554H23.7931V103.104H27.2414V99.6554Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.125,
    y: 43.1252,
    width: 33.75,
    height: 33.75,
    rx: 9.375,
    fill: "#FFD0D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2374 57.0867C66.1506 57.0507 66.0739 57.02 65.9922 56.9892C66.0331 56.9225 66.0637 56.8558 66.1097 56.7943C66.3243 56.4813 66.4009 56.1325 66.406 55.7683C66.4163 55.1784 66.3805 52.9316 66.36 52.4032C66.3447 52.0031 66.5746 51.685 66.9527 51.408C67.1366 51.2746 67.4739 50.9976 67.668 50.8694C67.6856 50.8619 67.7026 50.8534 67.7191 50.8438C67.7191 50.8694 67.714 50.8797 67.714 50.895C67.6425 51.208 67.479 51.5876 67.479 52.3416C67.4483 52.6186 67.479 55.0245 67.4739 55.2912C67.4739 55.7427 67.1928 56.1223 66.8556 56.4813C66.6666 56.6814 66.4622 56.8712 66.263 57.0661C66.2579 57.0713 66.2476 57.0764 66.2374 57.0867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1133 57.5457C56.5011 57.3767 55.92 57.2139 55.314 57.0448C55.3962 56.4968 55.5874 55.9708 55.8763 55.4982C56.7072 54.1333 57.9693 53.432 59.5624 53.3067C60.5808 53.2253 61.5867 53.288 62.555 53.6511C64.0795 54.2272 64.8729 55.3417 65.0416 56.9071C65.0854 57.314 65.0978 63.4001 65.0978 66.0299V66.3555H63.3485V64.9905C63.286 65.0344 63.2548 65.0406 63.236 65.0594C62.4301 66.0737 61.3368 66.5684 60.056 66.6999C59.0751 66.8001 58.113 66.7437 57.1883 66.4056C55.7388 65.8734 54.8642 64.5522 54.9141 63.0307C54.9391 62.1541 55.1641 61.3589 55.8076 60.714C56.2847 60.2459 56.8645 59.8964 57.5007 59.6934C58.4816 59.3678 59.4812 59.1111 60.4683 58.8105C60.9931 58.6477 61.5179 58.4787 62.024 58.2658C62.605 58.0216 63.0049 57.5895 63.0236 56.9384C63.0486 56.2747 62.73 55.7362 62.1364 55.4231C61.7512 55.2268 61.3347 55.0997 60.9057 55.0474C59.8873 54.9284 58.8939 55.0224 58.0755 55.7424C57.5819 56.1807 57.3257 56.7505 57.1508 57.3704C57.1383 57.4267 57.1258 57.4768 57.1133 57.5457ZM63.1173 59.1048C62.7612 59.5619 62.2926 59.781 61.8116 59.9501C60.9556 60.2506 60.081 60.5074 59.2125 60.7891C58.619 60.9832 58.038 61.1961 57.5257 61.5718C56.5448 62.2919 56.5885 64.3331 58.0505 64.7839C58.4261 64.8991 58.8141 64.9685 59.2063 64.9905C60.0685 65.0344 60.9244 64.9467 61.6929 64.5272C62.5675 64.0513 63.1173 63.3375 63.1298 62.3169C63.1423 61.2963 63.1361 60.2819 63.1298 59.2676C63.1401 59.2132 63.1358 59.157 63.1173 59.1048Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.125,
    y: 43.1252,
    width: 33.75,
    height: 33.75,
    rx: 9.375,
    stroke: "white",
    strokeWidth: 3.75
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 9.5,
    stroke: "#AFAFAF",
    strokeOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9147_38331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreQrV2);
export default __webpack_public_path__ + "static/storeQR-v2.45d45f03.svg";
export { ForwardRef as ReactComponent };